Ext.define('ViewProjects', {
    extend: 'Ext.panel.Panel',
    grid: null,
    windowObject: null,
    taskContextMenu: null,
    rowContext: null,
    statics: {
        accessPropertyName: "access.manage.projects",
        accessPropertyViewName: "access.view.projects",
        accessPropertyNameAdvanced: "access.advmanage.projects"
    },
    cat: "p",
    text: Lang.projekty.capitalise(),
    buttonIconCls: "iconProjects",
    layout: 'border',
    frame: false,
    border: false,
    showClosed: false,
    initComponent: function () {
        this.buttonId = "main-view-button-" + this.id;
        this.buildGrid();
        this.items = [{
            region: "north",
            xtype: 'toolbar',
            items: [{
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconNew",
                text: Lang.nowy.capitalise(),
                scope: this,
                handler: this.dodajObiekt,
                disabled: !validPrivilegesOperatorComplex(ViewProjects.accessPropertyNameAdvanced + "/add")
            }, {
                id: this.id + "bedit",
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconEdit",
                text: Lang.edytuj.capitalise(),
                scope: this,
                handler: this.edytujObiekt,
                disabled: !validPrivilegesOperatorComplex(ViewProjects.accessPropertyName + "/update")
            }, {
                id: this.id + "bshowRaport",
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconEdit",
                text: Lang.podglad_raportu.capitalise(),
                scope: this,
                handler: this.showOnlyRaport,
                disabled: !validPrivilegesOperatorComplex(ViewProjects.accessPropertyViewName)
            }, {
                id: this.id + "bclose",
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconClose",
                text: Lang.zamknij.capitalise(),
                scope: this,
                handler: this.zamknijProject,
                disabled: !validPrivilegesOperatorComplex(ViewProjects.accessPropertyNameAdvanced + "/delete")
            },  {
                iconAlign: 'left',
                iconCls: "iconRefresh",
                text: Lang.odswiez.capitalise(),
                scope: this,
                handler: this.refreshDatastore
            }, {
                xtype: "checkbox",
                id: this.id + "autorefresh",
                boxLabel: Lang.pokazywac_zamkniete,
                listeners: {
                    scope: this,
                    change: this.showClosedF
                }
            }]
        }, {
            region: "center",
            xtype: 'panel',
            frame: false,
            border: false,
            layout: 'fit',
            items: [this.grid]
        }];
        this.callParent(arguments);
    },
    showFirst: function (eventMain) {
        eventMain.on("firmaChangeContext", this.changeContext, this);
    },
    remove: function () {
        this.callParent(arguments);
    },
    show: function () {
        this.callParent(arguments);
        this.showState = true;
        this.refreshDatastore();
    },
    hide: function () {
        this.showState = false;
        this.callParent(arguments);
    },
    onDestroy: function () {
        this.taskContextMenu.destroy();
        this.callParent(arguments);
    },
    changeContext: function (eAppFIRMACTX, eAppFIRMACTXold) {
        if (this.showState) {
            this.refreshDatastore();
        }
    },
    buildGrid: function () {
        var store = Ext.create('Ext.data.Store', {
            autoLoad: false,
            remoteSort: true,
            remoteFilter: true,
            pageSize: 50,
            model: Ext.define(null, {
                extend: 'Ext.data.Model',
                idProperty: 'id',
                fields: [{
                    name: 'id',
                    mapping: 'id'
                }, {
                    name: 'nazwa',
                    mapping: 'nazwa'
                }, {
                    name: 'active',
                    mapping: 'active'
                }, {
                    name: 'czasotwarcia',
                    mapping: 'czasotwarcia',
                    type: 'date'
                }, {
                    name: 'czaszamkniecia',
                    mapping: 'czaszamkniecia',
                    type: 'date'
                }, {
                    name: 'operator',
                    mapping: 'operator'
                }]
            }),
            proxy: {
                type: 'ajax',
                url: 'rest/projects/getList',
                actionMethods: {
                    read: 'POST'
                },
                reader: {
                    type: 'json',
                    rootProperty: 'data',
                    totalProperty: 'total',
                    id: 'id'
                },
                filterParam: "filters",
                listeners: {
                    scope: this,
                    exception: handlGridLoadExceptionJsonRpcL
                }
            },
            listeners: {
                scope: this,
                load: handlGridLoadStoreCheckJsonRpcL
            }
        });
        store.on("load", function (store) {
            Ext.defer(function () {
                var count = store.getTotalCount();
                var pageSize = store.getPageSize();
                var pageCount = Math.ceil(count / pageSize);
                var currentPage = store.currentPage;
                if (currentPage > pageCount && pageCount > 0) {
                    --store.currentPage;
                }
            }, 1000, this);
        }, this);
        var cols = [{
            header: "ID",
            width: 145,
            sortable: true,
            dataIndex: 'id',
            filter: {
                type: 'numeric'
            },
            filterable: true,
            hidden: true
        }, {
            header: Lang.nazwa,
            flex: 2,
            sortable: true,
            dataIndex: 'nazwa',
            filter: {
                type: 'string'
            },
            filterable: true
        }, {
            header: Lang.operator,
            flex: 2,
            sortable: true,
            dataIndex: 'operator',
            filter: {
                type: 'string'
            },
            filterable: true
        }, {
            header2: Lang.active,
            menuText: Lang.active,
            header: Lang.active,
            flex: 1,
            sortable: true,
            dataIndex: 'active',
            renderer: renderBool3,
            filter: {
                type: 'boolean'
            },
            filterable: true
        }, {
            header: Lang.czas_otwarcia,
            flex: 3,
            sortable: true,
            dataIndex: 'czasotwarcia',
            renderer: Ext.util.Format.dateRenderer(),
            filter: {
                type: 'date'
            },
            filterable: true
        }, {
            header: Lang.czas_zamkniecia,
            flex: 3,
            sortable: true,
            dataIndex: 'czaszamkniecia',
            renderer: Ext.util.Format.dateRenderer(),
            filter: {
                type: 'date'
            },
            filterable: true
        }];
        this.groupStore = Ext.create('Ext.data.Store', {
            fields: [{
                name: 'id',
                mapping: 'id'
            }, {
                name: 'nazwa',
                mapping: 'nazwa'
            }],
            listeners: {
                load: function () {
                    this.insert(0, [{
                        id: 0,
                        nazwa: Lang.brak_grupy
                    }]);
                }
            }
        });

        this.grid = new Ext.ux.grid.GridPanelExd({
            plugins: {
                gridfilters: true
            },
            store: store,
            columns: cols,
            frame: false,
            border: false,
            stateId: "this.grid-" + this.id + (AppFIRMACTX == null ? "-all" : "-"),
            stateful: true,
            stripeRows: true,
            enableHdMenu: true,
            selModel: {
                selType: 'rowmodel',
                mode: 'multi'
            },
            bbar: {
                xtype: 'pagingtoolbarexd',
                displayInfo: true,
                pagingStore: store
            }
        });
        this.grid.addListener("rowdblclick", function () {
            if (validPrivilegesOperatorComplex(ViewProjects.accessPropertyName + "/update"))
                if (!this.grid.getSelectionModel().hasSelection() || this.grid.getSelectionModel().getSelection() == null || this.grid.getSelectionModel().getSelection().length == 0) {
                } else {
                    var row = this.grid.getSelectionModel().getSelection()[0];
                    if (row != null) {
                        this.edytujObiekt();
                    }
                }
        }, this);
        this.grid.addListener("render", function () {
            this.manageSelect(this.grid.getSelectionModel());
        }, this);
        this.grid.store.addListener("load", function () {
            updateCzasRefreshSerwer();
        });
        this.grid.addListener("select", function (selectionModel, record, index) {
            this.manageSelect(selectionModel);
        }, this);
        this.grid.addListener("selectionchange", function (selectionModel, record, index) {
            this.manageSelect(selectionModel);
        }, this);
        this.taskContextMenu = new Ext.menu.Menu();
        this.taskContextMenu.add([{
            id: this.id + "bedit2",
            iconAlign: 'left',
            iconCls: "iconEdit",
            text: Lang.edytuj.capitalise(),
            scope: this,
            handler: this.edytujObiekt,
            disabled: !validPrivilegesOperatorComplex(ViewProjects.accessPropertyName + "/update") && !validPrivilegesOperatorComplex(ViewProjects.accessPropertyWynajemName + "/update")
        }, {
            id: this.id + "bshowRaport2",
            iconAlign: 'left',
            iconCls: "iconEdit",
            text: Lang.podglad_raportu.capitalise(),
            scope: this,
            handler: this.showOnlyRaport,
            disabled: !validPrivilegesOperatorComplex(ViewProjects.accessPropertyViewName)
        }, {
            id: this.id + "bclose2",
            iconAlign: 'left',
            iconCls: "iconClose",
            text: Lang.zamknij.capitalise(),
            scope: this,
            handler: this.zamknijProject,
            disabled: !validPrivilegesOperatorComplex(ViewProjects.accessPropertyNameAdvanced)
        }]);
        this.grid.addListener("rowcontextmenu", function (grid, record, tr, rowIndex, e) {
            this.rowContext = this.grid.getStore().getAt(rowIndex);
            this.manageSelect();
            this.taskContextMenu.showAt(e.getXY());
            e.preventDefault();
        }, this);
        this.taskContextMenu.addListener("hide", function () {
            this.rowContext = null;
        }, this);
        this.grid.addListener("containercontextmenu", function (grid, e) {
            this.rowContext = null;
            this.manageSelect();
            this.taskContextMenu.showAt(e.getXY());
            e.preventDefault();
        }, this);
    },
    manageSelect: function () {
        var bedit = Ext.getCmp(this.id + "bedit");
        var bshowonlyraport = Ext.getCmp(this.id + "bshowRaport");
        var bdelete = Ext.getCmp(this.id + "bclose");
        var bedit2 = Ext.getCmp(this.id + "bedit2");
        var bshowonlyraport2 = Ext.getCmp(this.id + "bshowRaport2");
        var bdelete2 = Ext.getCmp(this.id + "bclose2");
        if (!this.grid.getSelectionModel().hasSelection() || this.grid.getSelectionModel().getSelection() == null || this.grid.getSelectionModel().getSelection().length == 0) {
            bdelete.setDisabled(true);
            bedit.setDisabled(true);
            bshowonlyraport.setDisabled(true);
        } else {
            var row = this.grid.getSelectionModel().getSelection()[0];
            bdelete.setDisabled(!validPrivilegesOperatorComplex(ViewProjects.accessPropertyNameAdvanced + "/delete") || row.data.active === false);
            bedit.setDisabled(!validPrivilegesOperatorComplex(ViewProjects.accessPropertyName + "/update"));
            bshowonlyraport.setDisabled(!validPrivilegesOperatorComplex(ViewProjects.accessPropertyViewName));
        }
        if (this.rowContext == null) {
            bdelete2.setDisabled(true);
            bedit2.setDisabled(true);
            bshowonlyraport2.setDisabled(true);
        } else {
            bdelete2.setDisabled(!validPrivilegesOperatorComplex(ViewProjects.accessPropertyNameAdvanced + "/delete") || this.rowContext.data.active === false);
            bedit2.setDisabled(!validPrivilegesOperatorComplex(ViewProjects.accessPropertyName + "/update"));
            bshowonlyraport2.setDisabled(!validPrivilegesOperatorComplex(ViewProjects.accessPropertyViewName));
        }
    },
    refreshDatastore: function () {
        this.grid.store.getProxy().setExtraParams({
            showClosed: this.showClosed
        });
        this.grid.store.load();
    },
    dodajObiekt: function () {
        windowObject = Ext.create('WindowProject', {
            callbackF: Ext.Function.bind(this.refreshDatastore, this)
        });
        windowObject.showW(0);
    },
    edytujObiekt: function () {
        var id = 0;
        if (!this.grid.getSelectionModel().hasSelection() && this.rowContext == null) {
            Ext.MessageBox.alert(Lang.error, Lang.prosze_wybrac_obiekt);
            return;
        } else {
            if (this.rowContext != null) {
                id = this.rowContext.id;
            } else if (this.grid.getSelectionModel().getSelection() != null && this.grid.getSelectionModel().getSelection().length > 0) {
                id = this.grid.getSelectionModel().getSelection()[0].id;
            }
        }
        windowObject = Ext.create('WindowProject', {
            showOnlyRaport: false,
            callbackF: Ext.Function.bind(this.refreshDatastore, this)
        });
        windowObject.showW(id);
    },
    showOnlyRaport: function () {
        var id = 0;
        if (!this.grid.getSelectionModel().hasSelection() && this.rowContext == null) {
            Ext.MessageBox.alert(Lang.error, Lang.prosze_wybrac_obiekt);
            return;
        } else {
            if (this.rowContext != null) {
                id = this.rowContext.id;
            } else if (this.grid.getSelectionModel().getSelection() != null && this.grid.getSelectionModel().getSelection().length > 0) {
                id = this.grid.getSelectionModel().getSelection()[0].id;
            }
        }
        windowObject = Ext.create('WindowProject', {
            showOnlyRaport: true,
            callbackF: Ext.Function.bind(this.refreshDatastore, this)
        });
        windowObject.showW(id);
    },
    showClosedF: function (cb, checked) {
        this.showClosed = checked;
        this.refreshDatastore();
    },
    zamknijProject: function () {
        var id = 0;
        if (!this.grid.getSelectionModel().hasSelection() && this.rowContext == null) {
            Ext.MessageBox.alert(Lang.error, Lang.prosze_wybrac_obiekt);
            return;
        } else {
            if (this.rowContext != null) {
                id = this.rowContext.id;
            } else if (this.grid.getSelectionModel().getSelection() != null && this.grid.getSelectionModel().getSelection().length > 0) {
                id = this.grid.getSelectionModel().getSelection()[0].id;
            }
        }
        Ext.MessageBox.show({
            title: Lang.zamykanie,
            message: Lang.czy_napewno_zamknac_projekt,
            buttons: Ext.MessageBox.YESNO,
            scope: this,
            fn: function (btn) {
                if (btn == "yes") {
                    sendAjaxDataJsonRpcL("rest/projects/closeProject", {
                        id: id
                    }, this, function (data) {
                        if (data.status) {
                        } else {
                            Ext.MessageBox.alert(Lang.error, data.error);
                        }
                        this.refreshDatastore();
                    });
                }
            }
        });
    }
});
